import { FC } from 'react'
import { ProductPageLayout } from '~/components/ProductPageLayout/ProductPageLayout'
import { ProductPage } from '~/components/ProductPage/WardrobeProductPage'
import { WardrobeProductConfigurator } from '~/components/ProductPage/productTypes/wardrobe'
import { OpeningType } from '~/components/ThreeDModel/furnitureConfig'

export const preview = {
  name: 'products.wardrobe.3.name',
  link: '/product/wardrobe/4',
  // src: '/wardrobe/Grey/maner/Base 60/H2400/right/2000-4.png',
  src: '/cdn/ready-products/wardrobe/2000-4_2.png',
  dimensions: '200x240x50',
  color: 'Grey',
  price: 11810,
}

const Product: FC = () => {
  return (
    <ProductPageLayout>
      <ProductPage
        components={WardrobeProductConfigurator}
        name={preview.name}
        values={{
          imageCarousel: ['/cdn/ready-products/wardrobe/2000-4_2.png'],
          colors: preview.color,
          dimensions: {
            width: 200,
            height: 240,
            depth: 50,
            plintHeight: 6,
          },
          furniture: {
            openingType: OpeningType.RoundHandle,
            guides: 'homepage.configurator.fittings.guides.options.2',
          },
          sections: {
            number: 2,
            mirror: 'nu',
            arrangement: [
              {
                src: '/cdn/wardrobe/filling/Grey/2400/1.png',
                width: 100,
                height: 240,
              },
              {
                src: '/cdn/wardrobe/filling/Grey/2400/1.png',
                width: 100,
                height: 240,
              },
            ],
            opening: [
              {
                src: '/cdn/wardrobe/opening-double.png',
                width: 100,
                height: 254,
              },
              {
                src: '/cdn/wardrobe/opening-double.png',
                width: 100,
                height: 254,
              },
            ],
          },
          price: preview.price,
        }}
      />
    </ProductPageLayout>
  )
}

export default Product
